export default {
  header: 'Homepage',
  dashboard: {
    header: 'Dashboard',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    static: 'Statistics',
    agent: 'FC',
    policyType: 'Policy Type',
    chart: {
      casesByProvider: 'Cases by Provider',
      commissionByProvider: 'Commission by Provider',
      commissionByAgent: 'Commission by FC',
      fycByAgent: 'FYC by FC (Top 10)',
      casesTrend: 'Cases Trend',
      fycTrend: 'FYC Trend',
      commissionTrend: 'Commission Trend',
      noData: 'No relevant data.',
      unit: {
        casesByProvider: 'No. of Cases',
        commissionByProvider: 'Commission Amount',
        commissionByAgent: 'Commission Amount',
        commissionTrend: 'Commission Amount',
        fycByAgent: 'FYC Amount',
        casesTrend: 'No. of Cases',
        fycTrend: 'FYC Amount'
      }
    }
  },
  message: {
    headers: {
      serviceRecord: 'Service Record',
      message: 'Message',
      bulletin: 'Bulletin',
      birthday: 'Birthday',
      renewal: 'Renewal'
    },
    bulletin: {
      attachment: 'Attachment',
      edit: 'Edit Bulletin',
      provider: 'Provider',
      policyType: 'Policy Type',
    },
    word: 'characters',
    createBulletin: 'New Bulletin',
    subject: 'Subject',
    bulletinSubject: 'Bulletin Subject',
    bulletinContent: 'Bulletin Content',
    category: 'Category'
  },
  customerPolicy: {
    header: 'My Policy',
    detail: {
      header: 'Policy Detail'
    },
    agentName: 'FC Name',
    nextPaymentDate: 'Next Payment Date'
  }
}



// WEBPACK FOOTER //
// ./src/Homepage/langs/en_us/index.js